import React, { useEffect } from 'react';
import classnames from 'classnames';
import { Draggable } from 'react-beautiful-dnd';
import { DragHandle, IDragDropListItem } from './drag-drop-list';

interface IProps<T> {
    index: number;
    listItem: T;
    renderItem: (props: T, index: number) => JSX.Element;
    onItemRendered?: (element: HTMLDivElement, index: number) => () => void | null;
    dragHandleBy?: DragHandle;
}

const DragDropListItem = <T extends IDragDropListItem>({ index, listItem, renderItem, onItemRendered, dragHandleBy = 'icon' }: IProps<T>): JSX.Element => {
    let dragableElement: HTMLDivElement = null;
    const isWholeRow = dragHandleBy === 'item';

    if (onItemRendered) {
        useEffect(() => {
            const onUnmount = onItemRendered(dragableElement, index);
            return () => {
                if (onUnmount) {
                    onUnmount();
                }
            };
        }, [listItem]);
    }

    return (
        <Draggable key={`item_${listItem.id}`} draggableId={`item_${listItem.id}`} index={index}>
            {(draggableProps, snapshot) => (
                <div
                    className={classnames('drag-drop-list__item', { 'drag-drop-list__item--dragging': snapshot.isDragging })}
                    ref={draggableItemRef => {
                        draggableProps.innerRef(draggableItemRef);
                        dragableElement = draggableItemRef;
                    }}
                    {...draggableProps.draggableProps}
                    {...(isWholeRow ? draggableProps.dragHandleProps : {})}
                >
                    {!isWholeRow && (
                        <div className='list-item__icon'>
                            <i {...draggableProps.dragHandleProps} tabIndex={-1} />
                        </div>
                    )}
                    {renderItem(listItem, index)}
                </div>
            )}
        </Draggable>
    );
};

export { DragDropListItem };
